// extracted by mini-css-extract-plugin
export default {"container":"AuthCommon_container__wrPWc","title":"AuthCommon_title__goVhY","description":"AuthCommon_description__6wwiJ","input":"AuthCommon_input__WDDlo"};